import ListUsersPage from './ListUsersPage';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetStoreByIdQuery } from '../../stores/store.api-slice';
import { useParams } from 'react-router-dom';

const ListUsersForStorePage: React.FC = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetStoreByIdQuery(id ?? skipToken);

  if (isLoading || id == null) {
    return <LoadingSpinner />;
  }

  return <ListUsersPage scope={'merchantStore'} store={data} />;
};

export default ListUsersForStorePage;
